// app.module.ts
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  APP_INITIALIZER,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FilterPipe } from './pipes/filter.pipe';
import { ErrorInterceptor, JwtInterceptor } from './services';
import { MaterialModule } from 'src/material.module';

import player from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';

import {
  DxDataGridModule,
  DxFormModule,
  DxTreeViewModule,
} from 'devextreme-angular';
import { DxDashboardControlModule } from 'devexpress-dashboard-angular';
import { GridsterModule } from 'angular-gridster2';
import { AutoScaleDirective } from './directives/auto-scale.directive'; 
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'; 
import { DevexpressI18nService } from './services/DevexpressI18nService';

// ngx-translate loader
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function playerFactory() {
  return player;
}

// <<< EKLE: APP_INITIALIZER factory
export function initDxLocale(i18n: DevexpressI18nService) {
  // Uygulama boot etmeden TR paketlerini yükle ve locale('tr') yapar
  return () => i18n.initTurkish();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }), // <- yalnızca bir kez
    HttpClientModule,
    AppRoutingModule,
    NgxSkeletonLoaderModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),

    FormsModule,
    ReactiveFormsModule,
    FilterPipe,
    BrowserAnimationsModule,
    MaterialModule,

    DxDataGridModule,
    DxFormModule,
    DxTreeViewModule,
    DxDashboardControlModule,

    GridsterModule,
    AutoScaleDirective,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },

    // Lottie
    provideLottieOptions({ player: () => player }),
DevexpressI18nService,
    // Provide AppComponent so pages/services that inject it via constructor
    // receive a DI-provided instance (prevents "No provider for AppComponent" errors).
    // Note: this creates a DI-managed instance; components should avoid
    // relying on DOM-specific state of the bootstrapped AppComponent.
    AppComponent,
  {
    provide: APP_INITIALIZER,
    useFactory: initDxLocale,
    deps: [DevexpressI18nService],
    multi: true,
  },
    // <<< EKLE: Uygulama başlamadan DevExpress TR locale yüklenir
    {
      provide: APP_INITIALIZER,
      useFactory: initDxLocale,
      deps: [DevexpressI18nService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
